import { PROTOCOL } from '@src/utils/locale';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';

const Config = {
  /**
   * 英文
   */
  en: {
    privacyPolicy: PROTOCOL[getLanguageByPath()].privacy,
    termsOfService: PROTOCOL[getLanguageByPath()].service,
    cookie: PROTOCOL[getLanguageByPath()].cookie
  },
  /**
   * 日语
   */
  ja: {
    privacyPolicy: PROTOCOL[getLanguageByPath()].privacy,
    termsOfService: PROTOCOL[getLanguageByPath()].service,
    cookie: PROTOCOL[getLanguageByPath()].cookie
  },
  /**
   * 韩语
   */
  ko: {
    privacyPolicy: PROTOCOL[getLanguageByPath()].privacy,
    termsOfService: PROTOCOL[getLanguageByPath()].service,
    cookie: PROTOCOL[getLanguageByPath()].cookie
  },
  /**
   * 中文繁体
   */
  'zh-Hant': {
    privacyPolicy: PROTOCOL[getLanguageByPath()].privacy,
    termsOfService: PROTOCOL[getLanguageByPath()].service,
    cookie: PROTOCOL[getLanguageByPath()].cookie
  },
  /**
   * 西班牙语
   */
  es: {
    privacyPolicy: PROTOCOL[getLanguageByPath()].privacy,
    termsOfService: PROTOCOL[getLanguageByPath()].service,
    cookie: PROTOCOL[getLanguageByPath()].cookie
  },
  /**
   * 葡萄牙语
   */
  pt: {
    privacyPolicy: PROTOCOL[getLanguageByPath()].privacy,
    termsOfService: PROTOCOL[getLanguageByPath()].service,
    cookie: PROTOCOL[getLanguageByPath()].cookie
  },
  /**
   * 德语
   */
  de: {
    privacyPolicy: PROTOCOL[getLanguageByPath()].privacy,
    termsOfService: PROTOCOL[getLanguageByPath()].service,
    cookie: PROTOCOL[getLanguageByPath()].cookie
  },
  /**
   * 法语
   */
  fr: {
    privacyPolicy: PROTOCOL[getLanguageByPath()].privacy,
    termsOfService: PROTOCOL[getLanguageByPath()].service,
    cookie: PROTOCOL[getLanguageByPath()].cookie
  },
  /**
   * 俄语
   */
  ru: {
    privacyPolicy: PROTOCOL[getLanguageByPath()].privacy,
    termsOfService: PROTOCOL[getLanguageByPath()].service,
    cookie: PROTOCOL[getLanguageByPath()].cookie
  },
  /**
   * 泰语
   */
  th: {
    privacyPolicy: PROTOCOL[getLanguageByPath()].privacy,
    termsOfService: PROTOCOL[getLanguageByPath()].service,
    cookie: PROTOCOL[getLanguageByPath()].cookie
  }
};
export default Config;
